import React, { FunctionComponent, useEffect } from "react";
import RoutesContainer from "../../routing/RoutesContainer";
import Outline from "../Outline";
import { connect } from "react-redux";
import verifySessions, {
  VerifySession,
} from "../../redux/actions/sessions/verifySession";

type AppProps = { authenticate: VerifySession };
const App: FunctionComponent<AppProps> = ({ authenticate }: AppProps) => {
  useEffect(() => {
    authenticate();
  }, [authenticate]);

  return (
    <Outline>
      <RoutesContainer />
    </Outline>
  );
};

const mapDispatchToProps = {
  authenticate: verifySessions,
};

export default connect(null, mapDispatchToProps)(App);
